"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AadHelper = void 0;
require("./tokenProvider");
const TokenProvider = __importStar(require("./tokenProvider"));
class AadHelper {
    constructor(kcsb) {
        if (!kcsb.dataSource) {
            throw new Error("Invalid string builder - missing dataSource");
        }
        if (!!kcsb.aadUserId && !!kcsb.password) {
            this.tokeProvider = new TokenProvider.UserPassTokenProvider(kcsb.dataSource, kcsb.aadUserId, kcsb.password, kcsb.authorityId);
        }
        else if (!!kcsb.applicationClientId && !!kcsb.applicationKey) {
            this.tokeProvider = new TokenProvider.ApplicationKeyTokenProvider(kcsb.dataSource, kcsb.applicationClientId, kcsb.applicationKey, kcsb.authorityId);
        }
        else if (!!kcsb.applicationClientId &&
            !!kcsb.applicationCertificateThumbprint && !!kcsb.applicationCertificatePrivateKey) {
            this.tokeProvider = new TokenProvider.ApplicationCertificateTokenProvider(kcsb.dataSource, kcsb.applicationClientId, kcsb.applicationCertificateThumbprint, kcsb.applicationCertificatePrivateKey, kcsb.applicationCertificateX5c, kcsb.authorityId);
        }
        else if (kcsb.managedIdentity) {
            this.tokeProvider = new TokenProvider.MsiTokenProvider(kcsb.dataSource, kcsb.msiClientId);
        }
        else if (kcsb.azLoginIdentity) {
            this.tokeProvider = new TokenProvider.AzCliTokenProvider(kcsb.dataSource);
        }
        else if (kcsb.accessToken) {
            this.tokeProvider = new TokenProvider.BasicTokenProvider(kcsb.dataSource, kcsb.accessToken);
        }
        else {
            let callback = kcsb.deviceCodeCallback;
            if (!callback) {
                // tslint:disable-next-line:no-console
                callback = (response) => console.log(response.message);
            }
            this.tokeProvider = new TokenProvider.DeviceLoginTokenProvider(kcsb.dataSource, callback);
        }
    }
    _getAuthHeader() {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield this.tokeProvider.acquireToken();
            return `${token.tokenType} ${token.accessToken}`;
        });
    }
}
exports.AadHelper = AadHelper;
;
exports.default = AadHelper;
//# sourceMappingURL=security.js.map